import moment from 'moment'
import pmsApi from 'services/api/pms'

import { ReactComponent as DownloadIcon } from './download.svg'
import styles from './LogRow.module.scss'

const statusNames = {
  Started: 'Started',
  StartingAnalysis: 'In progress',
  Finished: 'Finished',
  Cancelled: 'Cancelled',
  Failed: 'Failed'
}

const UploadLogRow = ({
  uploadedByName,
  uploadedOn,
  numberOfTotalRecords,
  numberOfNewSubscribers,
  numberOfUnUsableData,
  numberOfDuplicates,
  numberOfUpdatedSubscribers,
  uploadStatus,
  completedOn,
  numberOfRecordsInProgress,
  numberOfConversions,
  beginDate,
  endDate,
  reportKind,
  id
}) => {
  function downloadReport() {
    pmsApi.download({ reportId: id }).then(res => {
      res.forEach(element => {
        window.open(element.tempPublicPath)
      })
    })
  }

  return (
    <div className={styles.row}>
      <div className={[styles.uploadTimeCol, styles.col].join(' ')}>
        <small>{moment(uploadedOn).format('hh:mm A')}</small>
      </div>
      <div className={[styles.timeRangeCol, styles.col].join(' ')}>
        <span>
          {moment(beginDate).format('MMM D YYYY')} -{' '}
          {moment(endDate).format('MMM D YYYY')}
        </span>
        <small title={uploadedByName}>
          {numberOfConversions
            ? `${numberOfConversions} conversions`
            : reportKind === 'Unknown'
            ? 'Custom reports'
            : reportKind}
        </small>
      </div>
      <div className={[styles.uploadedNumberCol, styles.col].join(' ')}>
        {numberOfTotalRecords}
      </div>
      <div className={[styles.uploadedNumberCol, styles.col].join(' ')}>
        {numberOfNewSubscribers}
      </div>
      <div className={[styles.uploadedNumberCol, styles.col].join(' ')}>
        {numberOfUpdatedSubscribers}
      </div>
      <div className={[styles.uploadedNumberCol, styles.col].join(' ')}>
        {numberOfDuplicates}
      </div>
      <div className={[styles.uploadedNumberCol, styles.col].join(' ')}>
        {numberOfUnUsableData}
      </div>
      <div className={[styles.statusCol, styles.col].join(' ')}>
        <span className={styles[uploadStatus]}>
          <span>{statusNames[uploadStatus]}</span>
          {uploadStatus === 'Finished' && (
            <small>{moment(completedOn).format('MMM D, hh:mm A')}</small>
          )}
          {uploadStatus === 'StartingAnalysis' && (
            <small>{numberOfRecordsInProgress} remaining</small>
          )}
        </span>
      </div>
      <div className={[styles.downloadCol, styles.col].join(' ')}>
        <button onClick={downloadReport} className={styles.downloadBtn}>
          <DownloadIcon />
        </button>
      </div>
    </div>
  )
}

export default UploadLogRow
